import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/move_selected_meeting_items_wizard/MoveSelectedMeetingItemsForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import RadioGroup from '../../components/RadioGroup';
import ButtonGroup from '../../components/ButtonGroup';

@withRouter
@subscribe(Localization, 'localization')
@reduxForm({
  form: 'move_selected_meeting_items_wizard.move_selected_meeting_items',
})
class MoveSelectedMeetingItemsForm extends Component {
  render() {
    const {
      onBack,
      onCancel,
      onSubmitModeChange,
      options,
      secondarySubmitText,
      submitText,
    } = this.props;
    const handleCancel =
      onCancel ||
      (() =>
        setTableParams('all_meetings', {
          move_selected_meeting_items_wizard: undefined,
        }));

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={styles.form}>
          <Field
            name='move_action'
            component={RadioGroup}
            options={[
              {
                label: __('move-meeting-item.move-before'),
                value: 'before',
              },
              {
                label: __('move-meeting-item.move-after'),
                value: 'after',
              },
            ]}
          />

          <Field
            name='selected_item_id'
            component={Select}
            searchable
            noSort
            label={__('move-meeting-item.selected-item')}
            options={options}
          />
        </div>
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={handleCancel}
          />
          <div className={styles.actions}>
            <ButtonGroup right>
              {onBack && (
                <Button
                  gray
                  medium
                  middleText={__('button.back')}
                  onClick={onBack}
                />
              )}
              <Button
                lightBlue
                medium
                submit
                middleText={submitText || __('button.move')}
                spinning={this.props.submitting}
                onClick={() =>
                  onSubmitModeChange && onSubmitModeChange(false)
                }
              />
              {secondarySubmitText && (
                <Button
                  lightBlue
                  medium
                  middleText={secondarySubmitText}
                  spinning={this.props.submitting}
                  onClick={() => {
                    onSubmitModeChange && onSubmitModeChange(true);
                    setTimeout(() => this.props.submit(), 10);
                  }}
                />
              )}
            </ButtonGroup>
          </div>
        </div>
      </Form>
    );
  }
}

export default MoveSelectedMeetingItemsForm;
